<nz-time-picker
  [class]="class"
  [formControl]="control"
  [nzFormat]="format"
  [nzUse12Hours]="use12HoursFormat"
  [nzDisabled]="readOnly"
  [class.error]="
    (this.isFormSubmitted || this.control?.touched) && this.control?.errors
  "
></nz-time-picker>
